import { DetailedDatesRow } from '@/components/InfoTable/DatesRow';
import { OrganizerRow } from '@/components/InfoTable/OrganizerRow';
import { PriceRow } from '@/components/InfoTable/PriceRow';
import { VenueRow } from '@/components/InfoTable/VenueRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { useTheme } from '@mui/material/styles';

type Props = { imEvent: ImEventDto; customerSetting: CustomerSetting };

export const InfoTable: React.FC<Props> = ({ imEvent, customerSetting }) => {
  const {
    info: { showPrice, showOrganizer }
  } = customerSetting;
  const theme = useTheme();
  return (
    <Table
      size="small"
      sx={{ borderTop: `1px solid ${theme.palette.divider}` }}
    >
      <TableBody
        sx={{
          '& td': {
            verticalAlign: 'top',
            fontSize: {
              xs: theme.typography.body2.fontSize,
              sm: theme.typography.body1.fontSize
            }
          },
          '& td:nth-child(1)': {
            pl: 1,
            whiteSpace: 'nowrap'
          },
          '& td:nth-child(2)': {
            px: 0,
            wordWrap: 'break-word',
            wordBreak: 'break-all'
          }
        }}
      >
        <DetailedDatesRow imEvent={imEvent} />
        <VenueRow imEvent={imEvent} />
        {showPrice && <PriceRow imEvent={imEvent} />}
        {showOrganizer && <OrganizerRow imEvent={imEvent} />}
      </TableBody>
    </Table>
  );
};
